import { io } from 'socket.io-client';

const SOCKET_URL = 'https://test.profita.in';

export const socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket'],
});

export default socket;